import { Alert, AlertTitle, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

export const OpenOrdersAlert: FC = () => {
  const { t } = useTranslate()

  return (
    <Alert severity='warning' sx={{ mt: '1rem' }}>
      <AlertTitle variant='subtitle2'>
        {t(
          'openOrdersAlreadyExistForThisContainer',
          'Open orders already exist for this container.',
        )}
      </AlertTitle>

      <Typography variant='body2'>
        {t(
          'reviewTheExistingOrdersBelowBeforeCreatingNewOne',
          'Review the existing orders below before creating a new one.',
        )}
      </Typography>
    </Alert>
  )
}
